import httpRequest from '../../utils/httpRequest'
import { setLoading } from '../global/action'

export const SET_ACCOUNT_TRADE_HISTORY = 'SET_ACCOUNT_TRADE_HISTORY'

export const SET_TRADE_HISTORY = 'SET_TRADE_HISTORY'

export const SET_FETCH_TRADE_HISTORY = 'SET_FETCH_TRADE_HISTORY'

export const setTradeHistory = data => dispatch => dispatch({ type: SET_TRADE_HISTORY, data })

export const setFetchTradesHistory = data => dispatch => {
  dispatch({ type: SET_FETCH_TRADE_HISTORY, data })
}

export const setAccountTradeHistory = data => dispatch => {
  dispatch({ type: SET_ACCOUNT_TRADE_HISTORY, data })
}

export const getTradeHistoryQS = params => async dispatch => {
  try {
    dispatch(setFetchTradesHistory(true))
    const tradeHistory = await httpRequest.getOrderTradeHistoryQS(params)
    dispatch(setTradeHistory(tradeHistory))
    dispatch(setFetchTradesHistory(false))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
  }
}

export const getTradeHistoryByAddressQS = (params, withLoading) => async dispatch => {
  try {
    if (withLoading) {
      dispatch(setLoading(true))
    }
    const tradeHistory = await httpRequest.getOrderTradeHistoryQS(params)
    dispatch(setAccountTradeHistory(tradeHistory))
    if (withLoading) {
      dispatch(setLoading(false))
    }
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
  }
}
